module.exports = __webpack_public_path__ + "img/tech18mb.f48485cf.png";